import React from "react";

import { ColorSetter } from "./color-setter/color-setter";
import { TooltipProvider } from "./tooltip-provider/tooltip-provider";
import { AuthProvider } from "./auth/auth-provider";
import { ToastProvider } from "./toast-provider/toast-provider";

export const Providers = () => {
  return (
    <>
      <ColorSetter />
      <TooltipProvider />
      <AuthProvider />
      <ToastProvider />
    </>
  );
};
